import { red } from '@mui/material/colors';
import { lightgray, themegreen } from 'theme/color';
import { poppins600 } from 'theme/common.style';

export const counterCont = {
  paddingTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  padding: '5px',
  // backgroundColor: "#F9F9F9"
};

export const counterContMarket = {
  paddingTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  padding: '5px',
  backgroundColor: 'rgba(255, 255, 255, 1)',
};

export const counterContMarketUpper = {
  height: '100px',
  paddingTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '25px',
};

export const counterSub = {
  display: 'flex',
  // alignItems: "center",
  justifyContent: 'space-between',
  padding: '0px 10px 10px 10px',
};

export const counterAlignColum = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const timerCont = {
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 16px',
  borderColor: 'none',
  borderRadius: '15px',
  background: 'white',
  boxShadow: '5px 5px 20px rgba(151, 151, 151, 0.15)',
};
export const timerText = {
  background: themegreen,
  padding: '6px 8px',
  textAlign: 'center',
  color: 'white',
  borderRadius: '8px',
  ...poppins600,
};
